import { useEffect, useState } from "react";
import { ModalBase } from "../../../../components/Modals/ModalBase";
import { fechaMayorActual } from "../../../../utils/stringDate";
import { LibroComprasEditar } from "../../../../interfaces/libros/compras.interface";

export default function ModalEditLibro ({onClose, onAccept, selectedLibro}: {onClose: any, onAccept: any, selectedLibro: LibroComprasEditar}) {
  const [form, setForm] = useState({ descripcion: '', fechaDeclaracion: '' })
  const [errorForm, setErrorForm] = useState({ descripcion: '', fechaDeclaracion: '' })

  useEffect(() => {
    setForm({
      descripcion: selectedLibro.descripcion,
      fechaDeclaracion: selectedLibro.fechadeclaracion,
    })
  }, [selectedLibro]);

  const handleAccept = async () => {
    if (!form.descripcion || !form.fechaDeclaracion) {
      setErrorForm({
        descripcion: validateFormChange("descripcion", form.descripcion),
        fechaDeclaracion: validateFormChange("fechaDeclaracion", form.fechaDeclaracion),
      });
      return;
    }

    if (errorForm.descripcion || errorForm.fechaDeclaracion) return;

    onAccept(form);
  }

  const handleOnChange = (e: any) => {
    const {name, value} = e.target;
    const error = validateFormChange(name, value);

    setForm((prevForm) => ({
      ...prevForm,
      [name]: value
    }))
    setErrorForm((prevErrForm) => ({
      ...prevErrForm,
      [name]: error
    }))
  }

  const validateFormChange = (name: string, value: string) => {
    let error = '';
    switch (name) {
      case "descripcion": 
        if (value === "") error = "El campo de descripción es obligatorio";
        break;
      case "fechaDeclaracion":
        if (value === "") error = "El campo de fecha es obligatorio";
        else if (!fechaMayorActual(value)) error = "La fecha no puede ser mayor al día de hoy"
    }
    return error;
  }

  return (
    <ModalBase>
      <div className="dte-send-email-container">
        <div>
          <h3 className="card-title">Editar libro</h3>
        </div>
        <div className="separador"/>

        <div className='w-layout-hflex h-inputs'>
          <div className='label-input'>
            <label htmlFor='numId' className='field-label m'>
              Nombre de Libro <span style={{color: 'red'}}>*</span>
            </label>
            <input
              autoComplete='off'
              type='text'
              className='m text-field w-input'
              name='descripcion'
              data-name='descripcion'
              placeholder={`Descripción`}
              id='descripcion'
              maxLength={100}
              value={form.descripcion}
              onChange={handleOnChange}
            />
            {errorForm.descripcion && <p className='alert s'>{errorForm.descripcion}</p>}
          </div>
          {/* <div className='label-input'>
            <label htmlFor='numId' className='field-label m'>
              Fecha de Libro <span style={{color: 'red'}}>*</span>
            </label>
            <input
              autoComplete='off'
              type='month'
              className='m text-field w-input'
              name='fechaDeclaracion'
              data-name='fechaDeclaracion'
              placeholder={`Fecha declaración`}
              id='fechaDeclaracion'
              maxLength={100}
              value={form.fechaDeclaracion}
              onChange={handleOnChange}
            />
            {errorForm.fechaDeclaracion && <p className='alert s'>{errorForm.fechaDeclaracion}</p>}
          </div> */}
        </div>
        <div className="dte-send-email-footer" style={{marginTop: '16px'}}>
          <button className="button transparent w-inline-block" onClick={onClose}>
            Cancelar
          </button>
          <button className="button w-inline-block" onClick={handleAccept}>
            Guardar cambios
          </button>
        </div>
      </div>
    </ModalBase>
  )
}